import React from "react";
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Error from "./Error";

import { CSVLink, CSVDownload } from "react-csv";
import { connect } from "react-redux";
import LoadingIndicator from "../common/LoadingIndicator";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "unset",
    border: "unset",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    backgroundColor: "transparent",
    borderRadius: ".5rem",
  },
};

Modal.setAppElement("#root");

const schema = yup.object().shape({
  startDate: yup
    .date()
    .required("Campo requerido")
    .typeError("Debes seleccionar una fecha"),
  endDate: yup
    .date()
    .required("Campo requerido")
    .typeError("Debes seleccionar una fecha"),
});

const ModalReport = ({
  modalIsOpen,
  closeModal,
  title,
  subtitle,
  message,
  shouldCloseOnOverlayClick,
  shouldCloseOnEsc,
  onSubmit,
  orders,
  loading,
  success,
  error,
}) => {
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
  });

  if (loading)
    return (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={title}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        shouldCloseOnEsc={shouldCloseOnEsc}
      >
        <div
          className="bg-white rounded-lg overflow-hidden border-gray-200 border transform transition-all sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="bg-white px-4 pt-5 pb-4">
            <LoadingIndicator></LoadingIndicator>
          </div>
        </div>
      </Modal>
    );
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel={title}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
    >
      <div
        className="bg-white rounded-lg overflow-hidden border-gray-200 border transform transition-all sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div className="bg-white px-4 pt-5 pb-4">
          <div className="sm:flex sm:items-start">
            <div className="mt-3 text-center sm:mt-0 sm:text-left">
              <h3
                className="text-lg leading-6 font-bold text-gray-900"
                id="modal-headline"
                ref={(_subtitle) => (subtitle = _subtitle)}
              >
                {title}
              </h3>
              <div className="mt-2">
                <p className="text-sm leading-5 text-gray-700">{message}</p>
              </div>
            </div>
          </div>
        </div>
        <form className="bg-white px-4 pb-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="startDate"
            >
              Fecha de inicio
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="date"
              name="startDate"
              ref={register}
            ></input>
            <Error error={errors.startDate}></Error>
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="startDate"
            >
              Fecha de fin
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              type="date"
              name="endDate"
              ref={register}
            ></input>
            <Error error={errors.endDate}></Error>
          </div>
          <div className="bg-gray-50 py-3 sm:flex sm:flex-row-reverse">
            <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="submit"
                className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-blue-700 text-base leading-6 font-medium text-white shadow-sm hover:bg-blue-800 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                Generar reporte
              </button>
            </span>
            <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                onClick={closeModal}
                className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                Cancelar
              </button>
            </span>
          </div>
        </form>
        {success && (
          <CSVLink
            filename={"Reporte.csv"}
            data={orders}
            className="p-3 font-bold text-center text-white block rounded bg-brand-700 black"
          >
            Descargar archivo CSV
          </CSVLink>
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.restaurant.reportActions,
  };
};

export default connect(mapStateToProps, null)(ModalReport);
